<template>
  <div id="MessageCenter">
    <Head v-if="hackReset " />
    <div class="message">
      <div class="leftNav">
        <decLeftNav ref="LeftNav" />
      </div>
      <main>
        <div class="new" v-if="newMsg.length>0">
          <p>新消息</p>
          <ul>
            <li v-for="(itme,i) in newMsg" :key="i">
              <p class="new-left">
                <span>{{itme.datetime}}</span>
                {{itme.content}}
              </p>

              <div
                v-if="itme.content.indexOf('中国煤炭行业协会的审核')!=-1"
                @click="dispose(itme.address,1)"
              >确认</div>
              <div v-else @click="dispose(itme.address)">处理</div>
            </li>
            <!-- <li>
              <span>2020-03-20 20:15:16</span>
              最新申报已经开始，请立即申报
            </li>-->
          </ul>
        </div>
        <div class="history" v-if="oldMsg.length>0">
          <p>以下为历史消息</p>
          <ul>
            <li v-for="(itme,i) in oldMsg" :key="i">
              <span>{{itme.datetime}}</span>
              {{itme.content}}
            </li>
            <!-- <li>
              <span>2020-03-20 20:15:16</span>
              您的成果《关于煤炭行业发展前景预测》已被退回
            </li>-->
          </ul>
        </div>
        <div class="none" v-if="oldMsg.length==0&&newMsg.length==0">暂无消息</div>
      </main>
    </div>
    <RightNav />
    <Foot />
  </div>
</template>
<script>
import Head from "../../components/Head";
import Foot from "../../components/Foot";
import decLeftNav from "../../components/decLeftNav";
import RightNav from "../../components/RightNav";
export default {
  name: "MessageCenter",
  data() {
    return {
      ReportID: "",
      news: 1,
      newMsg: [],
      oldMsg: [],
      hackReset: true
    };
  },
  components: {
    Head,
    Foot,
    decLeftNav,
    RightNav
  },
  created() {
    window.scrollTo(0, sessionStorage.getItem("scroll"));
    this.getBgMsg();
  },
  mounted() {
    if (sessionStorage.getItem("isListGo") == "true") {
      this.ReportID = sessionStorage.getItem("reportID");
    } else {
      this.ReportID = sessionStorage.getItem("ReportID");
    }
    if (!sessionStorage.getItem("name")) {
      this.$router.replace("/Declare");
      return;
    }
    this.$refs.LeftNav.isTable();
    this.news = sessionStorage.getItem("msg");
    console.log(this.news, 11);
  },
  methods: {
    getBgMsg() {
      this.$axios
        .post(
          "message/index",
          this.$qs.stringify({
            type: 1,
            status: 0,
            token: sessionStorage.getItem("token")
          })
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            // console.log(res.data.data.list)
            this.newMsg = res.data.data.list;
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          }
        });
      this.$axios
        .post(
          "message/index",
          this.$qs.stringify({
            type: 1,
            status: 1,
            token: sessionStorage.getItem("token")
          })
        )
        .then(res => {
          console.log(res);
          if (res.data.code == 10000) {
            // console.log(res.data.data.list)
            this.oldMsg = res.data.data.list;
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          }
        });
    },
    dispose(address, i) {
      console.log(address);

      this.$axios
        .post(
          "message/updatestatus",
          this.$qs.stringify({
            type: 1,
            ReportID: address,
            token: sessionStorage.getItem("token")
          })
        )
        .then(res => {
          if (res.data.code == 10000) {
            if (i) {
              this.getBgMsg();
              this.hackReset = false;
              this.$nextTick(() => {
                this.hackReset = true;
              });
            } else {
              this.$router.replace("/tableList");
            }
          } else {
            this.$message({
              type: "warning",
              message: res.data.msg
            });
          }
        });

      // } else {
      //   this.$axios
      //     .post(
      //       "message/updatestatus",
      //       this.$qs.stringify({
      //         type: 1,
      //         ReportID: address,
      //         token: sessionStorage.getItem("token")
      //       })
      //     )
      //     .then(res => {
      //       console.log(res);
      //       if (res.data.code == 10000) {
      //         // console.log(res.data.data.list)
      //         this.$router.replace("/tableList");
      //       } else {
      //         this.$message({
      //           type: "warning",
      //           message: res.data.msg
      //         });
      //       }
      //     });
    }
  }
};
</script>
<style lang="less" scoped>
#MessageCenter {
  width: 100%;
  min-width: 1000px;
  .message {
    width: 100%;
    padding: 0 1.35rem;
    display: flex;
    align-items: stretch;
    margin-top: 0.6rem;
    font-size: 0.18rem;
    .leftNav {
      padding-right: 0.4rem;
      border-right: 0.01rem solid #e4e4e4;
    }
    main {
      width: 100%;
      margin-left: 0.3rem;
      li {
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #e2e2e2;
        padding-bottom: 0.2rem;
        margin-bottom: 0.3rem;
        span {
          color: #999;
          margin-right: 0.35rem;
        }
      }
      .none {
        color: #999;
        font-size: 0.3rem;
        margin-top: 1rem;
        text-align: center;
      }
      .new {
        p.new-left {
          margin-bottom: 0;
          color: #000;
          font-size: 0.16rem;
        }
        p {
          font-size: 0.24rem;
          color: #2d65d2;
          margin-bottom: 0.33rem;
        }

        li {
          div {
            width: 0.87rem;
            height: 0.37rem;
            line-height: 0.37rem;
            background: #2d65d2;
            color: #fff;
            text-align: center;
            border-radius: 0.2rem;
            cursor: pointer;
          }
        }
      }
      .history {
        p {
          color: #bbbbbb;
          text-align: center;
          margin-bottom: 0.6rem;
        }
      }
    }
  }
}
</style>